import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import RootLayout from "./Layout/RootLayout"
function App() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      easing: "ease",
      once: true,
    });
  }, []);
  return (
    <BrowserRouter>
      <>
        <Routes>
          <Route path="/*" element={<RootLayout />} />
          {/* <Route path="/login/*" element={<LoginLayout />} />
          <Route path="/signup" element={<Roles Login='signup' />} />
          <Route path="/admin/*" element={<AdminLogin />} />
          <Route path="/admins/*" element={<AdminLayout />} />
          <Route path="/mentees/*" element={<StudentLayout />} />
          <Route path="/mentor/*" element={<TeacherLayout />} /> */}
        </Routes>

        {/* <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        /> */}
      </>
    </BrowserRouter>
  );
}

export default App;
